import { render, staticRenderFns } from "./FinalEvaluationReadmissions.vue?vue&type=template&id=2be4ab27&scoped=true&"
import script from "./FinalEvaluationReadmissions.vue?vue&type=script&lang=js&"
export * from "./FinalEvaluationReadmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4ab27",
  null
  
)

export default component.exports